<template>
  
  <div class="ibox">
    <div class="ibox-title">
      <h2>DB Copy</h2>
    </div>
    <div :class="'ibox-content p-md' + (copyLoading ? ' sk-loading' : '')">

      <div v-if="copyLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <form role="form" @submit="copyDB" name="copyDBForm">
        <div class="form-group row">
          <div class="col">
            <v-select :options="listDBs" :getOptionLabel="listDBsOptionLabel" v-model="form.origin" placeholder="Select an origin DB" @keypress.enter.native.prevent="">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.origin"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
          <div class="col-md-auto">
            =>
          </div>
          <div class="col">
            <v-select :options="listDBs" :getOptionLabel="listDBsOptionLabel" v-model="form.destination" placeholder="Select a destination DB" @keypress.enter.native.prevent="">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.destination"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
        <button class="btn btn-primary ladda-button" data-style="zoom-in" type="submit">Copy</button>
      </form>

    </div>
  </div>
        
</template>

<style scoped>
  
</style>



<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component } from '@fwk-node-modules/vue-property-decorator';
import { mixins } from '@fwk-node-modules/vue-class-component';
import GenericPage from '@fwk-client/components/mixins/GenericPage.vue';
import * as api from '@fwk-client/utils/api';
import { messagesTypes, MessageTypes } from '@fwk-client/store/types';
import * as Ladda from 'ladda';

@Component({
  components: {}
})
export default class Copy extends Vue {

  copyLoading = false;

  listDBs:any[] = [];

  form:any = {
    origin : null,
    destination : null 
  }

  laddaSubmit:Ladda.LaddaButton|null = null;

  created() {
    this.updateListDBs();
  }

  mounted() {
    var button:HTMLButtonElement|null = document.querySelector( 'form[name=copyDBForm] button' );
    this.laddaSubmit = Ladda.create(button!);
  }

  updateListDBs() {
    // We need to get the list of available companies for the current logged in user
    var options:api.ApiVueOptions =  {
      app: this
    }
    api.getAPI('/api/admin/database/configs', options).then((response:any) => {
      if(response.configs) {  
        this.listDBs = response.configs;
      }
      else {
        this.listDBs = [];
      }
    });
  }

  listDBsOptionLabel(option:any) {
    return option.title;
  }

  copyDB(evt:Event) {
    evt.preventDefault();

    var options:api.ApiVueOptions =  {
      app: this
    }

    var input = {
      origin : this.form.origin.title,
      destination : this.form.destination.title
    }

    this.copyLoading = true;

    return api.postAPI('/api/admin/database/copy',input, options).then((response:any) => {
      if(response.result) {  
        console.log(response.result);
      }
      this.copyLoading = false;
    })
  }
  
}
</script>